import { Dumbbell, Heart, HeartPulse, Moon, Network, PersonStanding } from "lucide-react";

/**
 * Provider and category glyphs for the Connected Health screens. The brand
 * marks are approximations drawn inline (no vendor assets are bundled); every
 * glyph is decorative — the provider / category name is always rendered as
 * text beside it.
 */

function HealthConnectMark() {
  return (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true">
      <path
        d="M8.5 6.5a4 4 0 00-4 4c0 3.5 4 6.5 7.5 8.5"
        stroke="#1a73e8"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path
        d="M15.5 6.5a4 4 0 014 4c0 3.5-4 6.5-7.5 8.5"
        stroke="#34a853"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <circle cx="12" cy="11.5" r="2.4" fill="#1a73e8" />
    </svg>
  );
}

function WhoopMark() {
  return (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="#000" strokeWidth="1.4" />
      <path
        d="M7.5 9l2 6 2.5-5 2.5 5 2-6"
        stroke="#000"
        strokeWidth="1.4"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}

function OuraMark() {
  return (
    <span className="ch-oura-mark" aria-hidden="true">
      OURA
    </span>
  );
}

export function ProviderIcon({ provider }) {
  let mark;
  switch (provider) {
    case "healthkit":
      mark = <Heart aria-hidden="true" fill="#ff2d55" color="#ff2d55" size={24} />;
      break;
    case "health_connect":
      mark = <HealthConnectMark />;
      break;
    case "whoop":
      mark = <WhoopMark />;
      break;
    case "oura":
      mark = <OuraMark />;
      break;
    default:
      mark = <HeartPulse aria-hidden="true" size={24} />;
  }
  return <span className="ch-provider-tile">{mark}</span>;
}

const CATEGORY_ICONS = {
  ACTIVITY: PersonStanding,
  WORKOUTS: Dumbbell,
  HEART_RATE: Heart,
  SLEEP: Moon,
  ADDITIONAL_DATA: Network,
};

export function CategoryIcon({ categoryKey }) {
  const Icon = CATEGORY_ICONS[categoryKey] || HeartPulse;
  return (
    <span className="ch-category__icon">
      <Icon aria-hidden="true" size={24} strokeWidth={1.5} />
    </span>
  );
}
